import React from "react";
import PropTypes from 'prop-types'
import { ButtonCommonTop, ButtonCommonTopNew } from "../../pages/Theme";

const ButtonBlue = ({ onClick, title, width, bgColor, color, className, buttonStyle, textStyle, disabled, noCursor }) => {
    return (
        <ButtonCommonTopNew className={`${buttonStyle} ${"rounded-lg filter "}`}>
            <button
                className={`flex flex-row rounded-lg px-5 py-2 items-center justify-center hover:opacity-80
                        w-${width} ${className} filter 
                        ${disabled ? `hidden` : `block`}
                        ${noCursor ? `cursor-nodrop` : ``}
                        ${bgColor ?  `${bgColor}` : ``}
                        `}
                onClick={(onClick)}
            >
                <p className={`font-regular whitespace-nowrap text-xs lg:text-sm ${textStyle}`}>{title}</p>
            </button>
        </ButtonCommonTopNew>
    )
}

ButtonBlue.propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    width: PropTypes.string,
}

export default ButtonBlue
